import { BarChart2Icon, TargetIcon, TrendingUpIcon } from 'lucide-react';

export const ANALYTICS_CALLS_DASHBOARD_PAGE = {
  url: '/analytics/call-analytics',
  label: 'Call Analytics',
  title: 'Call Analytics',
  description: 'View and analyze call data for your business.',
  icon: BarChart2Icon,
};

export const ANALYTICS_AI_COACH_PAGE = {
  url: '/analytics/ai-coach',
  label: 'AI Coach',
  title: 'AI Coach',
  description: 'Your AI Coach information and contact details.',
  icon: TargetIcon,
};

export default [
  ANALYTICS_CALLS_DASHBOARD_PAGE,
  ANALYTICS_AI_COACH_PAGE,
  // {
  //   url: '/analytics/performance',
  //   label: 'Performance',
  //   title: 'Performance',
  //   description: 'Set your performance metrics and availability.',
  //   icon: TrendingUpIcon,
  // },
];
